import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".ModalButtons-module_modalCancel__wVH6K {\n  margin-bottom: 10px;\n}\n@media (min-width: 768px) {\n  .ModalButtons-module_modalCancel__wVH6K {\n    margin-right: 10px;\n    margin-bottom: 0;\n  }\n}";
var styles = {"modalCancel":"ModalButtons-module_modalCancel__wVH6K"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=ModalButtons.module.scss.js.map
